export const TILE_COUNT = 9;
export const GRID_SIZE = 3;
export let BOARD_SIZE = 350;
